import React from 'react';
import photo from '../../../media/img/products/header_proyectos.jpg';
import './productoInfoHeader.scss';

const ProductoInfoHeader = () => {
  return (
    <div className="producto-info-header">
      <div className="producto-info-header__img-container">
        <div className="triangle-left"></div>
        <img
          className="producto-info-header__img"
          src={photo}
          alt="Proyectos Wonderaly"
        />
        <div className="triangle-right"></div>
      </div>

      <div className="producto-info-header__content">
        <div className="producto-info-header__title">
          <h1 className="producto-info-header__title-text header-title__sub-page">
            WONDERALY PROYECTOS
          </h1>
        </div>
        <div className="producto-info-header__text">
          <p className="producto-info-header__text-paragraph header-subtitle__sub-page">
            Neuropsicología aplicada a la producción audiovisual e impacto
            social
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductoInfoHeader;
